import classnames from 'classnames'
import React, { useCallback } from 'react'

import { switchToTray, useFloorState } from '../../../firebase/hooks/useFloor'
import { cleanupTransientChyrons } from '../../../firebase/hooks/useOverlays'
import { useLastActiveMediaTrayCard } from '../../../firebase/hooks/useTray'
import usePlaybackIntent from '../../../Webinar/hooks/usePlaybackIntent'
import { MixPreview } from '../CustomMixes/MixPreview/MixPreview'

import './TrayView.scss'

const trayMix = {
  id: '',
  name: 'Tray',
  feeds: [
    {
      type: 'media',
      index: 0,
      media: { type: 'tray', id: 0 },
      crop: { zoom: 30, centerX: 0, centerY: 0 },
      position: { x: 0, y: 0, w: 100, h: 100 },
    },
  ],
  elements: [],
} as const

const TrayView = () => {
  const floor = useFloorState()
  const lastActiveMediaCard = useLastActiveMediaTrayCard()
  const { setPlaybackResumeIntent } = usePlaybackIntent()

  const isLive = floor?.layout === 'tray'

  const handleClick = useCallback(() => {
    void switchToTray()
    void cleanupTransientChyrons()

    if (lastActiveMediaCard?.type === 'video') {
      void setPlaybackResumeIntent()
    }
  }, [lastActiveMediaCard?.type, setPlaybackResumeIntent])

  if (!lastActiveMediaCard) return null

  return (
    <button
      type="button"
      className={classnames('tray-view-trigger')}
      onClick={handleClick}
      data-active={isLive}
    >
      <MixPreview mix={trayMix} />
      <div className="tray-view-baseline">
        {/* eslint-disable-next-line formatjs/no-literal-string-in-jsx */}
        <div>WebinarTray</div>
      </div>
    </button>
  )
}

export { TrayView }
